/* UPSPLUSBATTERY - product page shipping rate + column balance */
(function(){
  'use strict';

  /* ---------- 1. reference blocks go under the image on desktop ----------
     .product is a flex row and media/info are siblings, so CSS cannot move a
     child of the info column into the media column. The image leaves a tall
     empty gap, so the long reference blocks live there and the buy column
     stays short. Mobile is one column with the media FIRST, so we only do this
     on desktop - otherwise the spec table would sit above Add to cart. */
  var MOVE = ['.upsb-purchase-summary', '.upsb-pdp-trust'];
  var BP = 990;

  function shelf(){
    var media = document.querySelector('.product__media-wrapper');
    if (!media) return null;
    var s = media.querySelector('.upsb-shelf');
    if (!s){ s = document.createElement('div'); s.className = 'upsb-shelf'; media.appendChild(s); }
    return s;
  }
  function relocate(){
    var s = shelf(); if (!s) return;
    var wide = window.innerWidth >= BP;
    MOVE.forEach(function(sel){
      var el = document.querySelector(sel); if (!el) return;
      if (wide){
        if (el.parentElement !== s){ el.dataset.upsbMoved = '1'; s.appendChild(el); }
      } else if (el.dataset.upsbMoved === '1'){
        var info = document.querySelector('.product__info-container');
        if (info){ info.appendChild(el); delete el.dataset.upsbMoved; }
      }
    });
    s.hidden = !s.children.length;
  }
  var t; function schedule(){ clearTimeout(t); t = setTimeout(relocate, 60); }

  /* ---------- 2. rate calculator ---------- */
  /* CAP is matched against Shopify's rate NAMES, which are English whatever the
     storefront locale is. It is a matcher, not copy - never translate it. */
  var CAP = 'Guaranteed maximum';

  /* The widget writes its text at runtime, so it has to speak the page's
     language. Detected from <html lang> first, then the /fr path prefix.
     Quebec French, and no em dashes in it (house rule). */
  var STR = {
    en: {
      toggle: 'Calculate shipping', postal: 'Postal code', province: 'Province', go: 'Get rates',
      contact_url: '/pages/contact',
      asking: 'Asking the carriers…',
      enter_postal: 'Enter a full postal code.',
      choose_option: 'Choose an option first.',
      unreachable: 'Could not reach the carriers. Please try again.',
      no_quote: 'We cannot quote this item online.',
      ask_text: 'Ask us for a freight quote',
      ask_tail: '. We usually reply the same business day.',
      adds_nothing: 'Adds <b>nothing</b> to your shipping.',
      adds_amount: 'Adds <b>%AMOUNT%</b> to your shipping.',
      cart_total_prefix: 'Total for everything in your cart. ',
      live_rate: 'Live carrier rate to this postal code.'
    },
    fr: {
      toggle: 'Calculer la livraison', postal: 'Code postal', province: 'Province', go: 'Obtenir les tarifs',
      contact_url: '/fr/pages/contact',
      asking: 'Interrogation des transporteurs…',
      enter_postal: 'Entrez un code postal complet.',
      choose_option: 'Choisissez d’abord une option.',
      unreachable: 'Impossible de joindre les transporteurs. Veuillez réessayer.',
      no_quote: 'Nous ne pouvons pas coter cet article en ligne.',
      ask_text: 'Demandez une soumission de transport',
      ask_tail: '. Nous répondons généralement le jour ouvrable même.',
      adds_nothing: 'N’ajoute <b>rien</b> à vos frais de livraison.',
      adds_amount: 'Ajoute <b>%AMOUNT%</b> à vos frais de livraison.',
      cart_total_prefix: 'Total pour tout votre panier. ',
      live_rate: 'Tarif transporteur en direct pour ce code postal.'
    }
  };
  var LANG = (function(){
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (l.indexOf('fr') === 0) return 'fr';
    var p = location.pathname;
    return (p === '/fr' || p.indexOf('/fr/') === 0) ? 'fr' : 'en';
  })();
  var I18N = STR[LANG];
  function t(k, fb){ var v = I18N[k]; return (typeof v === 'string' && v.length) ? v : fb; }
  /* The block still renders these four in English; retitle them here so the
     whole widget matches the page. */
  (function localiseChrome(){
    if (LANG === 'en') return;
    var r = document.querySelector('[data-upsb-ship]');
    if (!r) return;
    var b = r.querySelector('[data-ship-toggle]'); if (b) b.textContent = I18N.toggle;
    var z = r.querySelector('[data-ship-zip]');
    if (z) { z.setAttribute('placeholder', I18N.postal); z.setAttribute('aria-label', I18N.postal); }
    var p = r.querySelector('[data-ship-prov]'); if (p) p.setAttribute('aria-label', I18N.province);
    var g = r.querySelector('[data-ship-go]'); if (g) g.textContent = I18N.go;
  })();

  var TTL = 6 * 60 * 60 * 1000;

  function ratesFor(prov, zip){
    var q = 'shipping_address%5Bcountry%5D=Canada' +
            '&shipping_address%5Bprovince%5D=' + encodeURIComponent(prov) +
            '&shipping_address%5Bzip%5D=' + encodeURIComponent(zip.replace(/\s+/g,''));
    return fetch('/cart/shipping_rates.json?' + q)
      .then(function(r){ return r.ok ? r.json() : {shipping_rates:[]}; })
      .catch(function(){ return {shipping_rates:[]}; })
      .then(function(b){ return (b && b.shipping_rates) || []; });
  }
  function cheapest(list){
    var c = list.filter(function(o){ return o.name.indexOf(CAP) === -1; });
    var use = c.length ? c : list;
    if (!use.length) return null;
    return use.reduce(function(a,b){ return Number(b.price) < Number(a.price) ? b : a; });
  }

  function init(){
    var root = document.querySelector('[data-upsb-ship]');
    if (!root || root.dataset.upsbShipInit) return;
    root.dataset.upsbShipInit = '1';

    var toggle = root.querySelector('[data-ship-toggle]'),
        panel  = root.querySelector('[data-ship-panel]'),
        zipEl  = root.querySelector('[data-ship-zip]'),
        provEl = root.querySelector('[data-ship-prov]'),
        goEl   = root.querySelector('[data-ship-go]'),
        outEl  = root.querySelector('[data-ship-out]');

    try {
      var z = localStorage.getItem('upsb_zip'), p = localStorage.getItem('upsb_prov');
      if (z) zipEl.value = z; if (p) provEl.value = p;
    } catch(e){}

    toggle.addEventListener('click', function(){
      var open = panel.hidden;
      panel.hidden = !open; root.classList.toggle('is-open', open);
      if (open) zipEl.focus();
    });

    function variantId(){
      var i = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return i ? i.value : null;
    }
    function qty(){
      var q = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
      var n = q ? parseInt(q.value,10) : 1; return (n && n > 0) ? n : 1;
    }
    function money(n){ return '$' + Number(n).toFixed(2); }
    /* full postal code, never the FSA: rates measurably differ inside one FSA
       (J4W 1B2 = GLS $13.81 vs J4W 3K5 = Canpar $13.53) */
    function key(v,n,z,p){ return 'upsb_r_' + v + '_' + n + '_' + p + '_' + String(z).replace(/\s+/g,'').toUpperCase(); }
    function cGet(k){ try{ var v=JSON.parse(localStorage.getItem(k)||'null');
      return (v && (Date.now()-v.t) < TTL) ? v.d : null; }catch(e){ return null; } }
    function cSet(k,d){ try{ localStorage.setItem(k, JSON.stringify({t:Date.now(),d:d})); }catch(e){} }
    function post(u,b){ return fetch(u,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(b)}); }

    function render(d){
      if (!d.rates.length){
        outEl.innerHTML = '<p class="upsb-ship__err">' + t('no_quote', 'We cannot quote this item online.') + '</p>' +
          '<p class="upsb-ship__note"><a href="' + I18N.contact_url + '">' +
          t('ask_text', 'Ask us for a freight quote') + '</a>' +
          t('ask_tail', '. We usually reply the same business day.') + '</p>';
        return;
      }
      var list = d.rates.filter(function(o){ return o.name.indexOf(CAP) === -1; });
      if (!list.length) list = d.rates;
      list = list.slice().sort(function(a,b){ return Number(a.price)-Number(b.price); }).slice(0,3);

      var head = '';
      if (d.delta !== null && d.delta !== undefined){
        head = '<p class="upsb-ship__delta">' +
               (Number(d.delta) <= 0.005
                 ? t('adds_nothing', 'Adds <b>nothing</b> to your shipping.')
                 : t('adds_amount', 'Adds <b>%AMOUNT%</b> to your shipping.')
                     .replace('%AMOUNT%', money(d.delta))) +
               '</p>';
      }
      outEl.innerHTML = head +
        '<ul class="upsb-ship__list">' + list.map(function(o,i){
          return '<li class="upsb-ship__opt' + (i===0?' is-best':'') + '">' +
                 '<span>' + o.name.split(' — ')[0] + '</span>' +
                 '<b>' + money(o.price) + '</b></li>';
        }).join('') + '</ul>' +
        '<p class="upsb-ship__note">' +
          (d.combined ? t('cart_total_prefix', 'Total for everything in your cart. ') : '') +
          t('live_rate', 'Live carrier rate to this postal code.') + '</p>';
    }

    var busy = false;
    function run(){
      if (busy) return;
      var zip = (zipEl.value||'').trim();
      if (zip.replace(/\s+/g,'').length < 6){
        outEl.innerHTML = '<p class="upsb-ship__err">' + t('enter_postal', 'Enter a full postal code.') + '</p>'; return; }
      var vid = variantId();
      if (!vid){ outEl.innerHTML = '<p class="upsb-ship__err">' + t('choose_option', 'Choose an option first.') + '</p>'; return; }
      var n = qty(), prov = provEl.value;
      try{ localStorage.setItem('upsb_zip',zip); localStorage.setItem('upsb_prov',prov); }catch(e){}

      var k = key(vid,n,zip,prov), hit = cGet(k);
      if (hit){ render(hit); return; }

      busy = true; goEl.disabled = true;
      outEl.innerHTML = '<p class="upsb-ship__loading">' + t('asking', 'Asking the carriers…') + '</p>';

      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(before){
        var had = null;
        before.items.forEach(function(i){ if (String(i.variant_id)===String(vid)) had = i; });
        var combined = before.item_count > 0;

        /* the cart as it stands - needs NO mutation, so it is a free read */
        var basePromise = combined ? ratesFor(prov, zip).then(cheapest) : Promise.resolve(null);

        return basePromise.then(function(base){
          return post('/cart/add.js', {items:[{id:Number(vid), quantity:n}]})
            .then(function(){ return ratesFor(prov, zip); })
            .then(function(rates){
              /* restore that one line exactly - the cart is never cleared */
              return post('/cart/change.js', {id:String(vid), quantity: had ? had.quantity : 0})
                .then(function(){
                  var withIt = cheapest(rates);
                  var delta = (base && withIt) ? Math.max(0, Number(withIt.price) - Number(base.price)) : null;
                  var d = {rates:rates, combined:combined, delta:delta};
                  cSet(k, d); render(d);
                  document.dispatchEvent(new CustomEvent('upsb:rates',
                    {detail:{variant:vid, zip:zip, count:rates.length, delta:delta}}));
                });
            });
        });
      }).catch(function(){
        outEl.innerHTML = '<p class="upsb-ship__err">' + t('unreachable', 'Could not reach the carriers. Please try again.') + '</p>';
      }).then(function(){ busy = false; goEl.disabled = false; });
    }

    goEl.addEventListener('click', run);
    zipEl.addEventListener('keydown', function(e){ if (e.key==='Enter'){ e.preventDefault(); run(); } });
  }

  /* ---------- 3. STAGING SHIM (2026-09-24) ----------
     Previews two product-page changes whose real home is sections/main-product.liquid
     (patch in the upsplusbattery repo, content/catalog/2026-09-24-improvements/): the fit
     guarantee and the quantity-field label. It does nothing once the Liquid version renders;
     remove it after that file is pushed. Also names the Google store-widget iframe. */
  function shim(){
    var box = document.querySelector('.upsb-purchase-summary');
    if (box && !box.querySelector('.upsb-purchase-summary__fit') && box.querySelector('.upsb-purchase-summary__models')){
      var ret = box.querySelector('.upsb-purchase-summary__returns');
      if (ret){
        var fit = document.createElement('p');
        fit.className = 'upsb-purchase-summary__returns upsb-purchase-summary__fit';
        fit.innerHTML = (LANG === 'fr')
          ? '<strong>Compatibilité garantie pour les modèles indiqués.</strong> Si cette batterie ne convient pas à un modèle UPS indiqué sur cette page, nous payons le retour et vous envoyons la bonne batterie ou vous remboursons, à votre choix.'
          : '<strong>Fit guaranteed for the models listed.</strong> If this battery does not fit a UPS model listed on this page, we pay return shipping and send the correct battery or refund you, your choice.';
        ret.parentNode.insertBefore(fit, ret);
      }
    }
    var q = document.querySelector('input.quantity__input[id^="Quantity-"]');
    if (q && !q.hasAttribute('aria-labelledby')){
      var lab = document.querySelector('[id^="quantity-label-"]');
      if (lab) q.setAttribute('aria-labelledby', lab.id);
    }
  }
  function nameWidgetFrame(){
    var title = (LANG === 'fr') ? 'Évaluation de la boutique sur Google' : 'Google store rating';
    function apply(){
      var f = document.getElementById('merchantwidgetiframe');
      if (f && !f.getAttribute('title')){ f.setAttribute('title', title); return true; }
      return !!f;
    }
    if (apply() || !window.MutationObserver) return;
    var mo = new MutationObserver(function(){ if (apply()) mo.disconnect(); });
    mo.observe(document.body, {childList:true, subtree:true});
    setTimeout(function(){ mo.disconnect(); }, 20000);
  }

  function boot(){ shim(); nameWidgetFrame(); init(); relocate(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('resize', schedule);
  var info = document.querySelector('.product__info-container');
  if (info && window.MutationObserver) new MutationObserver(schedule).observe(info, {childList:true});
})();